import React from 'react';
import Routes from './router';

class App extends React.Component {
  render() {
    return <Routes />;
  }
}
export default App;
